import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class SharedService {

  public hideLoaderForced: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public forceHideOfLoader() {
    this.hideLoaderForced.next(true);
  }

  public removeForceHideOfLoader() {
    this.hideLoaderForced.next(false);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/shared/shared.service.ts